(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-tabs-accordion"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.content-tabs-accordion').forEach(section => {
    // --- Tabs (desktop) ---
    const tabs = section.querySelectorAll('.cta-tab');
    const mediaPanes = section.querySelectorAll('.cta-media__pane');
    const panels = section.querySelectorAll('.cta-panel');

    if (tabs.length) {
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const idx = tab.dataset.idx;

          tabs.forEach(t => {
            const isActive = t === tab;
            t.classList.toggle('is-active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

            mediaPanes.forEach(m => {
                const active = m.dataset.idx === idx;
                m.classList.toggle('is-active', active);
                m.setAttribute('aria-hidden', active ? 'false' : 'true');
            });
            panels.forEach(p => {
                const active = p.dataset.idx === idx;
                p.classList.toggle('is-active', active);
                p.setAttribute('aria-hidden', active ? 'false' : 'true');
            });
        });

      });
    }

    // --- Mobile accordion: allow only one <details> open at a time ---
    // const accItems = section.querySelectorAll('.cta-accordion .cta-acc');
    // if (accItems.length) {
    //   accItems.forEach(acc => {
    //     acc.addEventListener('toggle', () => {
    //       if (!acc.open) return; // only act when a details just opened
    //       accItems.forEach(other => {
    //         if (other !== acc) other.open = false; // close others
    //       });
    //     });
    //   });
    // }

        // --- Mobile accordion: smooth open/close + only one open at a time ---
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const accItems = Array.from(section.querySelectorAll('.cta-accordion .cta-acc'));

    function animateOpen(detailsEl) {
      if (detailsEl.open) return;

      // close others (smoothly)
      accItems.forEach(other => {
        if (other !== detailsEl && other.open) animateClose(other);
      });

      detailsEl.classList.remove('is-closing');
      detailsEl.open = true;

      if (prefersReducedMotion) return;

      const content = detailsEl.querySelector('.cta-acc__content');
      if (!content) return;

      // start from 0 -> expand to scrollHeight -> then reset to auto
      content.style.height = '0px';
      content.style.overflow = 'hidden';

      const endHeight = content.scrollHeight;

      requestAnimationFrame(() => {
        content.style.height = endHeight + 'px';
      });

      const onEnd = (e) => {
        if (e.propertyName !== 'height') return;
        content.removeEventListener('transitionend', onEnd);
        // allow natural height after animation
        content.style.height = '';
        content.style.overflow = '';
      };

      content.addEventListener('transitionend', onEnd);
    }

    function animateClose(detailsEl) {
      if (!detailsEl.open) return;

      if (prefersReducedMotion) {
        detailsEl.open = false;
        detailsEl.classList.remove('is-closing');
        return;
      }

      const content = detailsEl.querySelector('.cta-acc__content');
      if (!content) {
        detailsEl.open = false;
        return;
      }

      detailsEl.classList.add('is-closing');

      // set explicit current height -> animate to 0 -> then actually close
      const startHeight = content.scrollHeight;

      content.style.overflow = 'hidden';
      content.style.height = startHeight + 'px';

      requestAnimationFrame(() => {
        content.style.height = '0px';
      });

      const onEnd = (e) => {
        if (e.propertyName !== 'height') return;
        content.removeEventListener('transitionend', onEnd);

        detailsEl.open = false;
        detailsEl.classList.remove('is-closing');

        content.style.height = '';
        content.style.overflow = '';
      };

      content.addEventListener('transitionend', onEnd);
    }

    if (accItems.length) {
      accItems.forEach(detailsEl => {
        const summary = detailsEl.querySelector('summary');
        if (!summary) return;

        // Avoid double-binding if Shopify re-renders section in editor
        if (summary.dataset.ctaBound === 'true') return;
        summary.dataset.ctaBound = 'true';

        summary.addEventListener('click', (e) => {
          e.preventDefault();
          if (detailsEl.open) animateClose(detailsEl);
          else animateOpen(detailsEl);
        });
      });
    }



  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
